import { useEffect, useState } from "react";

const useLoadSPPositions = (axiosPrivate, reloadlistdata, navigate, location, url) => {
  const [listdata, setListdata] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    const getUSpositions = async () => {
      try {
        const response = await axiosPrivate.get("/api/positions/" + url);
        if (response.data.message !== "No positions exist.") {
          setListdata(response.data);
        }
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getUSpositions();
    return () => controller.abort();
  }, [reloadlistdata]);
  return listdata;
};

export default useLoadSPPositions;
